import React from "react";
import "./LocationInfo.css";

const LocationInfo = () => {
  return (
    <div className="location-info">
      <div className="location-row">
        <span className="location-icon">📍</span>
        <p>
          2400 Dunaújváros<br />
          Apáczai Csere János út 13<br />
          Dunaferr Szakképzési Centrum <br />
          földszinti küzdőterme (MMK mellett)
        </p>
      </div>

      <div className="location-row">
        <span className="location-icon">📞</span>
        <p>Kőkuti Krisztián<br /><a href="tel:+36-70 369 9264">+36-70 369 9264</a></p>
      </div>

      <div className="location-row">
        <span className="location-icon">📞</span>
        <p>Forster Zoltán<br /><a href="tel:+36-70 608 9130">+36-70 608 9130</a></p>
      </div>

      <div className="location-row">
        <span className="location-icon">✉️</span>
        <p><a href="mailto:dunajudo@gmail.com">dunajudo@gmail.com</a></p>
      </div>

      <a
        className="location-button"
        href="https://www.google.com/maps?q=Hungary%202400%20Dunaújváros,%20Apáczai%20Csere%20János%20út%2013"
        target="_blank"
        rel="noopener noreferrer"
      >
        Megnyitás Google Térkép-ben
      </a>
    </div>
  );
};

export default LocationInfo;
